<template>
  	<div class="build-cont xhm-layout">
  	  	<el-form :inline="true" :model="params" class="demo-form-inline" size="mini">
  	  	  	<el-form-item label="是否使用">
  	  	  	  	<el-select v-model="params.is_used" clearable>
  	  	  	  	  	<el-option label="是" :value="1"></el-option>
  	  	  	  	  	<el-option label="否" :value="0"></el-option>
  	  	  	  	</el-select>
  	  	  	</el-form-item>
  	  	  	<el-form-item>
  	  	  	  	<el-button type="primary" @click.native="getList">查询</el-button>
  	  	  	</el-form-item>
  	  	  	<el-form-item>
  	  	  	  	<el-button type="primary" @click="onAdd">新增</el-button>
  	  	  	</el-form-item>
  	  	</el-form>

  	  	<el-dialog title="新增" :visible.sync="dialogVisible">
  	  	  	<el-form :model="form" label-width="120px" size="small">
  	  	  	  	<el-form-item label="描述">
  	  	  	  	  	<el-input v-model="form.name"></el-input>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="优惠金额">
  	  	  	  	  	<el-input v-model.number="form.coupon_money" type="number" :min="0"></el-input>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="有效期">
  	  	  	  	  	<el-date-picker	v-model="form.timer" type="daterange" start-placeholder="开始" end-placeholder="结束" :default-time="['00:00:00', '23:59:59']" value-format="timestamp"></el-date-picker>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="电话">
  	  	  	  	  	<el-input type="number" v-model.number="form.tel"></el-input>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="数量" v-if="onSwitch">
  	  	  	  	  	<el-input type="number" v-model.number="form.num"></el-input>
  	  	  	  	</el-form-item>
  	  	  	</el-form>
  	  	  	<div slot="footer" class="dialog-footer">
  	  	  	  	<el-button type="primary" @click.native="submitForm" size="small">确 定</el-button>
  	  	  	</div>
  	  	</el-dialog>

		<in-table ref="myTable" :intApi="intApi" :columns="columns" :params="params" @onChange="handleChange"></in-table>

  	</div>
</template>
<script>
import InTable from '@/views/Comm/InTable'
// import KtPag from "../Comm/KtPag"
import { format } from "@/utils/comm"
export default {
  	data() {
  	  	return {
			intApi: this.$api.comApi.coupongetList,
  	  	  	dialogVisible: false,
  	  	  	onSwitch:true,
  	  	  	form: {},
			params: { page: 1, limit: 10 },
			columns: [
				{ prop: 'coupon_uuid', label: '优惠券标识', minWidth: 120 },
				{ prop: 'coupon_money', label: '优惠金额', width: 110 },
				{ prop: 'name', label: '描述', width: 150 },
				{ prop: 'tel', label: '电话', width: 150 },
				{ prop: 'create_time', label: '创建时间', width: 150, render: (h, { row, column }) => (h('span', format(row[column.prop])))},
				{ label: '有效期', render: (h, { row }) => (h('span',this.getTimer(row)))},
				{ prop: 'is_used', label: '是否使用', width: 80, render: (h, { row, column }) => (h('span', row[column.prop] === 0 ? '否' : '是'))},
				{ label: '操作', width: 80, fixed: 'right', render: (h, { row }) => {
					return h('el-button', {
						props: { type: 'text', size: 'small' },
						on: { click: () => { this.editor(row) } }
					}, '修改')
				}},
			]
  	  	};
  	},	
  	components: {
		InTable
  	},
	mounted: function () {
		this.getList()
	},
  	methods: {
  	  	getList: function () {
			this.$nextTick(() => { this.$refs.myTable.handleList(this.params) })
  	  	},
  	  	onAdd() {
  	  	  	this.onSwitch = true
  	  	  	this.form = {}
  	  	  	this.dialogVisible = true
  	  	},
  	  	editor(data) {
  	  	    this.onSwitch = false
			let { coupon_uuid, coupon_money, name,tel, valid_endTime, valid_startTime } = data
			let timer = []
			timer[0] = new Date(valid_startTime).getTime()
  	  	    timer[1] = new Date(valid_endTime).getTime()
			this.form = { coupon_uuid, name, coupon_money, tel, timer }
  	  	    this.dialogVisible = true
  	  	},
  	  	submitForm: function () {
			let data = {...this.form}
			let { timer } = data
			if(!timer || timer.length === 0){
				return this.$message.error('请输入有效时间')
			}
			delete data.timer
  	  	    data.valid_startTime = timer[0]
			data.valid_endTime = timer[1]
			this.onSwitch ? this.addForm(data) : this.updateForm(data)
  	  	},
  	  	addForm: async function (option){
			try {
				const { status, message } = await this.$api.comApi.couponAdd(option)
				this.$message({showClose: true, message: status === '0' ? '新增成功' : 'message', type: status === '0' ? 'success' : 'error'})
				if(status === '0'){
					this.dialogVisible = false
					this.getList()
				}
			} catch (err) {
				this.$message.error(`数据异常：${err}`)
			}
  	  	},
  	  	updateForm: async function (option){
			try {
				const { status, message } = await this.$api.comApi.couponUpdate(option)
				this.$message({showClose: true, message: status === '0' ? '修改成功' : message, type: status === '0' ? 'success' : 'error'})
				if(status === '0'){
					this.dialogVisible = false
					this.getList()
				}
			} catch (err) {
				this.$message.error(`数据异常：${err}`)
			}
		},
		handleChange: function ({ page, limit }){
  	  	    let params = Object.assign({}, this.params, { page, limit })
			this.params = params
  	  	    this.getList()
  	  	},
  	  	getTimer(row) {
  	  	  	let start = format(row.valid_startTime);
  	  	  	let end = format(row.valid_endTime);
  	  	  	return start + " 至 " + end;
  	  	}
  	}
};
</script>
<style lang="scss">
.build-cont {
  padding: 10px;
}
</style>